import { useSyncExternalStore } from 'react';

/** Smal scherm (telefoon). Ook de grens van MobileWarning. */
export const PHONE_WIDTH_QUERY = '(max-width: 767px)';
/**
 * #1825 deel 3 — de touch-indeling: smal scherm óf grove aanwijzer (telefoon en tablet).
 * Eén definitie; de CSS gebruikt dezelfde tekst in `@media (max-width: 767px), (pointer: coarse)`.
 */
export const TOUCH_LAYOUT_QUERY = `${PHONE_WIDTH_QUERY}, (pointer: coarse)`;

/** Een hook die `query` volgt; false zonder matchMedia (SSR, oude browser). */
function mediaHook(query: string): () => boolean {
  const mql = () => (typeof window !== 'undefined' ? window.matchMedia?.(query) : undefined);
  const subscribe = (cb: () => void) => {
    const m = mql();
    m?.addEventListener('change', cb);
    return () => m?.removeEventListener('change', cb);
  };
  return function useMedia() {
    return useSyncExternalStore(
      subscribe,
      () => !!mql()?.matches,
      () => false
    );
  };
}

export const useTouchLayout = mediaHook(TOUCH_LAYOUT_QUERY);
/**
 * #1825 deel 4 eindreview (ruling D4e) — alleen het smalle scherm. De telefoon krijgt eigen
 * schermen (kaarten); een tablet is touch maar houdt de tabel met sorteren, Sosa en bulkacties.
 */
export const usePhoneLayout = mediaHook(PHONE_WIDTH_QUERY);
